export default __webpack_public_path__ + "static/media/approved.69da0bc5.png";